export enum ActionTypes {
  CreateOrder = "CREATEORDER",
  UpdateOrder = "UPDATEORDER",
  UpdateCart = "UPDATECART",
  UpdateUserInterfaceMenuView = "UPDATEUSERINTERFACEMENUVIEW",
  UpdateUserInterfaceMenuStatus = "UPDATEUSERINTERFACEMENUSTATUS",
}
